
module.exports = {
  sampling: require('./sampling'),
  counting: require('./counting'),
  ranking: require('./ranking')
}
